<template>
  <div>
    <v-select
      label="Producto"
      v-model="selectedLocal"
      item-text="nombre"
      item-value="id"
      :items="all"
      prepend-icon="mdi-propane-tank"
      :tabindex="tabindex"
    ></v-select>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'ProductosSelectComponent',
  model: {
    prop: 'productoid',
    event: 'change'
  },
  props: {
    productoid: {
      type: Number,
      default: null
    },
    tabindex: {
      type: [String, Number],
      default: null
    }
  },
  async created () {
    await this.onEstablecerDB();
    await this.onEstablecerDefault();
  },
  computed: {
    ...mapGetters('Productos', ['all']),
    selectedLocal: {
      get () {
        return this.productoid
      },
      set (value) {
        this.$emit('change', value);
        // Usamos 'find' en lugar de 'filter' ya que solo esperamos un resultado.
        const producto = this.all.find(item => item.id === value);
        // Suponiendo que el objeto tiene una propiedad 'coeficiente'.
        if (producto.coeficiente) {
          this.$emit('coeficiente', producto.coeficiente);
        } else {
          // Manejo de error si el coeficiente no existe
          console.error('El producto seleccionado no tiene un coeficiente.');
          this.$emit('coeficiente', 1);
        }
      }
    },
  },
  methods: {
    ...mapActions('Productos', ['onFetch']),
    ...mapMutations('Productos', ['setAll']),
    async onEstablecerDB () {
      // Verifica si los productos ya están cargados
      if (this.all?.length) return;
      try {
        const aux = this.getFromSession() || await this.onFetch();
        if (aux) this.setAll(aux);
      } catch (error) {
        console.error('Error al cargar los productos:', error);
      }
    },
    onEstablecerDefault () {
      const aux = this.all[0]?.id;
      const coeficiente = this.all[0]?.coeficiente;
      this.$emit('change', aux)
      this.$emit('coeficiente', coeficiente)
    },
    getFromSession () {
      const aux = window.sessionStorage.getItem('pro');
      return aux ? JSON.parse(aux) : null;
    }
  }
}
</script>
